var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBegetWhiteBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 603.6 290.8",
    style: {
      enableBackground: "new 0 0 603.6 290.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{opacity:0.4;fill:#2FA3E7;enable-background:new    ;}\n\t.st3{fill:url(#SVGID_00000182488220281454733780000013567004375253244092_);}\n\t.st4{opacity:0.5;fill:url(#SVGID_00000021086801961396324130000001880434669402049716_);enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.6,104.3c2.2-9,4.2-17.4,6.5-25.7c0.3-1.2,2.1-2.2,3.4-2.7c20.2-7.5,42.7-1.1,57,16.2 c23.4,28.2,14.6,72.7-17.4,88.7c-27,13.5-59.4,0.6-71-28.7c-2.6-6.5-4.3-13.9-4.4-20.9c-0.4-34.4-0.2-68.9-0.2-103.3 c0-0.7,0.1-1.4,0.1-2.3c6,0,11.9,0,18.2,0c0,1.4,0,2.8,0,4.2c0,33.1,0,66.2,0,99.3c0,10.2,3.1,19.4,9.9,27.1 c13.9,15.6,36.3,15.5,50.1-0.3c13.7-15.7,12.6-40.9-2.4-55.4c-13-12.5-32.5-12.5-45.5,0C46.7,101.6,45.4,102.6,43.6,104.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.4,138.5c-14.2,0-28.5,0-42.7,0c-14.3,0-28.5,0-43.3,0c3.5,13.2,10.7,22.8,23.4,27.4 c13.1,4.8,24.6,1,38-12.5c5,2.9,10.2,5.9,15.6,9.1c-8.8,12.3-20,20.4-34.8,22.7c-29.3,4.5-56.4-16.3-60.6-46.1 c-2.7-19.2,2-36.3,15.5-50.4c26.4-27.5,70.8-18,85.5,18.1C248.1,117.1,249.4,128.8,247.4,138.5z M228.6,120.1 c-2-16.1-17.9-29.4-34.3-29.1c-15.5,0.3-31.3,14.4-32.5,29.1C184.1,120.1,206.2,120.1,228.6,120.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M496.6,138.5c-28.7,0-57.1,0-86.1,0c3.1,12.5,9.7,21.9,21.4,26.6c16,6.4,29,1,39.8-11.7 c5.1,3,10.2,5.9,15.7,9.1c-1.1,1.5-2,2.8-3.1,4.1c-21.3,25.8-58.7,25.8-79.9,0C385.8,144.2,387,110.1,407,89 c27.1-28.5,73.1-18,86.8,19.9C497.2,118.3,498.2,127.8,496.6,138.5z M477.7,120.1c-1.4-15.8-18.1-29.6-34.8-29 c-15.3,0.5-31.6,15.4-31.8,29C433.3,120.1,455.5,120.1,477.7,120.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M574.6,157.5c2,5.9,4,11.9,5.9,17.9c0.2,0.8-0.3,2.3-1,2.9c-15.9,12.6-44.4,9.5-57.3-6.2 c-4-4.9-6.3-10.4-6.3-16.7c0-35.2,0-70.4,0-105.5c0-0.7,0.1-1.4,0.1-2.3c6,0,11.8,0,18,0c0,9.5,0,19.1,0,28.9c11.1,0,21.8,0,32.8,0 c0,6.2,0,12.1,0,18.3c-10.8,0-21.4,0-32.5,0c-0.1,1.5-0.2,2.6-0.2,3.8c0,18.4,0.1,36.8-0.1,55.1c0,4.4,1.8,7.5,5.1,9.9 c7.9,5.8,22.2,5.8,30-0.1C571.2,161.8,572.7,159.6,574.6,157.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.0703,
    y1: -30.3338,
    x2: 366.5195,
    y2: 268.8918,
    gradientTransform: "matrix(1 0 0 -1 0 292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09235534,
    style: {
      stopColor: "#CEE903"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    style: {
      stopColor: "#01C8F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5424,
    style: {
      stopColor: "#01C2EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#01B2E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7079,
    style: {
      stopColor: "#0196DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8034,
    style: {
      stopColor: "#0170CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#0040B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000B9D"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.4,176.7c15.5-10.1,25.8-27.6,25.8-47.5c0-31.3-25.3-56.6-56.6-56.6S264,98,264,129.2 c0,31.3,25.3,56.6,56.6,56.6c21.2,0,38.4,17.2,38.4,38.4s-17.2,38.4-38.4,38.4c-21.2,0-38.4-17.2-38.4-38.4c0-5.1,1-9.9,2.8-14.3 l11.9,2.8l-15.1-23.9l-24.3,14.6l9.6,2.3c-2,5.8-3.1,12-3.1,18.5c0,31.3,25.3,56.6,56.6,56.6s56.6-25.3,56.6-56.6 C377.2,204.3,366.9,186.8,351.4,176.7z M282.2,129.2c0-21.2,17.2-38.4,38.4-38.4c21.2,0,38.4,17.2,38.4,38.4s-17.2,38.4-38.4,38.4 C299.4,167.6,282.2,150.4,282.2,129.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M320.6,90.9c20.9,0,38.4,17.2,38.4,38.4s-17.2,38.4-38.4,38.4c11.4,0,21.9,3.4,30.8,9.1 C383.5,157.9,376.2,89.2,320.6,90.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023258843112087766300000014753251314372685240_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.317,
    y1: -6.121,
    x2: 330.3956,
    y2: 134.6401,
    gradientTransform: "matrix(1 0 0 -1 0 292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0003605769,
    style: {
      stopColor: "#41D71E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2016,
    style: {
      stopColor: "#40D424"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    style: {
      stopColor: "#3ECD34"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7647,
    style: {
      stopColor: "#3AC04F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#36B46A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023258843112087766300000014753251314372685240_)"
    },
    d: "M320.6,185.8c21.2,0,38.4,17.2,38.4,38.4 s-17.2,38.4-38.4,38.4c-21.2,0-38.4-17.2-38.4-38.4c0-5.1,1-9.9,2.8-14.3l11.9,2.8l-15.1-23.9l-24.3,14.6l9.6,2.3 c-2,5.8-3.1,12-3.1,18.5c0,31.3,25.3,56.6,56.6,56.6C372.9,280.8,388.1,185.3,320.6,185.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111902307331551092490000005939924423713496977_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.6,
    y1: 158.1655,
    x2: 370.4508,
    y2: 158.1655,
    gradientTransform: "matrix(1 0 0 -1 0 292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0003605769,
    style: {
      stopColor: "#0065FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9016,
    style: {
      stopColor: "#000B9D",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000111902307331551092490000005939924423713496977_)",
      enableBackground: "new"
    },
    d: " M320.6,90.9c20.9,0,38.4,17.2,38.4,38.4s-17.2,38.4-38.4,38.4c11.4,0,21.9,3.4,30.8,9.1C383.5,157.9,376.2,89.2,320.6,90.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBegetWhiteBg);
export default __webpack_public_path__ + "static/media/beget_white_bg.bd11c8ed4ac0701cd6bdc3996db06f79.svg";
export { ForwardRef as ReactComponent };